'use strict';

import { changeLangToCurrent, getCurrentLang } from '../langSwitcher/langSwitcher';
import { Buildings, isMobile, isDesktop, projectMode, settingsData, UIRoot } from '../../../settings';
import { dataArrayOfFlat, facingDictionary } from '../../cards/cardsConfig';
import {threeJsVariables} from "../../../settings";
import { ViewMode } from '../../../common';
import {getPropType, setInfoPointsLayoutDependsOnChildren} from "../../cards/unitCards/unitCardFunctions";
import {BaseElement} from "../../interfaces/BaseElement";
import { Price } from '../../cards/Price';
import { addFloorOrdinalSuffix, getFieldsFromAPI, isNumeric, numberWithCommas } from '../../../functions';

let tooltip = null;
let price = null;
export const createTooltip = () => {
    tooltip = new BaseElement()
      .addClass('flat-tooltip')
      .appendTo(UIRoot)
      .DOMElement;
    createHeader();
    createInfoPoints();
    price = config.property.settings?.displayPrice !== 'button' && new Price()
        .addBlock(document.querySelector(`.flat-tooltip__price-value`));
};

const createHeader = () => {
    const tooltipHeader = new BaseElement()
      .addClass('flat-tooltip__header', 'card__header')
      .appendTo(tooltip)
      .DOMElement;
    const tooltipTitleBox = new BaseElement()
      .addClass('flat-tooltip__title-box', 'card__title-box')
      .appendTo(tooltipHeader)
      .DOMElement;
    const tooltipSubtitle = new BaseElement()
      .addClass('flat-tooltip__subtitle-box', 'card__subtitle-box')
      .appendTo(tooltipHeader)
      .DOMElement;
    const tooltipTitle = new BaseElement('h3')
      .addClass('flat-tooltip__title', 'card__title')
      .appendTo(tooltipTitleBox)
      .DOMElement;
    const tooltipPrice = new BaseElement()
      .addClass('flat-tooltip__price', 'card__price')
      .appendTo(tooltipTitleBox)
      .DOMElement;
    new BaseElement('span')
      .addClass('flat-tooltip__flat-name', 'card__title-flat-name', 'language-string')
      .addAttribute('data-dictionary', 'Apt.')
      .appendTo(tooltipTitle);
    new BaseElement('span')
      .addClass('flat-tooltip__flat-number', 'card__title-flat-number', 'language-string')
      .appendTo(tooltipTitle);
    if (Buildings.getBuildingsInfoLength() > 1) {
        new BaseElement()
          .addClass('flat-tooltip__tower-name', 'card__tower-name')
          .appendTo(tooltipSubtitle);
            new BaseElement()
              .addClass('subtitle-separator')
              .appendTo(tooltipSubtitle);
    }
        const tooltipFloorNum = new BaseElement()
          .addClass('flat-tooltip__floor-number', 'card__floor-number')
          .appendTo(tooltipSubtitle)
          .DOMElement;
        new BaseElement('span')
          .addClass('flat-tooltip__floor-number-floor', 'card__floor_floor', 'language-string')
          .addAttribute('data-dictionary', 'floor')
          .appendTo(tooltipFloorNum)
          .innerHtml(changeLangToCurrent('floor') + ' ');
        new BaseElement('span')
          .addClass('flat-tooltip__floor-number_num', 'card__floor_num')
          .appendTo(tooltipFloorNum);

    new BaseElement('span')
      .addClass('flat-tooltip__price-value', 'card__price-value')
      .appendTo(tooltipPrice)
    new BaseElement('span')
      .addClass('flat-tooltip__rent-price-value', 'card__price-value')
      .appendTo(tooltipPrice);
    new BaseElement('span')
      .addClass('flat-tooltip__price-currency', 'card__price-currency', 'language-string')
      .appendTo(tooltipPrice);
}

const createInfoPoints = () => {
    new BaseElement()
      .addClass('flat-tooltip__info-points', 'card__info-points')
      .appendTo(tooltip);
    new BaseElement()
      .addClass('flat-tooltip__flat-number')
      .appendTo(tooltip);
    new BaseElement()
      .addClass('flat-tooltip__flat-model')
      .appendTo(tooltip);
}

export const updateTooltipText = async (selectedObject, crmDataObject) => {
    const isAmenity = selectedObject.userData.customSelection;
    if (!crmDataObject && isAmenity || !crmDataObject && (projectMode.LiteMode.modeIs('picture') || projectMode.LiteMode.modeIs('empty')))
        crmDataObject = selectedObject.userData.crm_data;

    if (!crmDataObject)
        return;

    isAmenity ?
      tooltip.classList.add('amenity') :
      tooltip.classList.remove('amenity');

    if (!isAmenity)
        tooltip.setAttribute('data-engineid', crmDataObject?.engineId);

    updateTooltipHeader(crmDataObject);
    updateTooltipInfoPoints(crmDataObject);
}

const updateTooltipHeader = (crmDataObject) => {
    let towerName;

    ((projectMode.LiteMode.isActive() && (projectMode.LiteMode.modeIs('picture') || projectMode.LiteMode.modeIs('empty'))) || config.features.privateHouseMode) ?
        towerName = Buildings.getBuilding(crmDataObject.buildingEngineId).info.towerName:
        towerName = Buildings.getActiveBuilding().info.towerName;

    let name;
    Array.isArray(towerName) ?
        name = towerName.find(el => el.lang === getCurrentLang()).value:
        name = towerName;

    const tooltipTowerName = document.querySelector('.flat-tooltip__tower-name');
    const tooltipFlatName = document.querySelector('.flat-tooltip__flat-name');
    const tooltipFlatNumber = document.querySelector('.flat-tooltip__flat-number');
    const tooltipFloorNum = document.querySelector('.flat-tooltip__floor-number_num');
    const subtitleBox = document.querySelector('.flat-tooltip__subtitle-box');

    tooltipFlatName.innerHTML = changeLangToCurrent(getPropType(crmDataObject.propType));

    if (tooltip.classList.contains('amenity')) {
        tooltipFlatNumber.classList.add('language-string');
        tooltipFlatNumber.setAttribute('data-dictionary', crmDataObject.propNum);
        tooltipFlatNumber.innerHTML = changeLangToCurrent(crmDataObject.propNum);
    } else {
        tooltipFlatNumber.classList.remove('language-string');
        tooltipFlatNumber.removeAttribute('data-dictionary');
        tooltipFlatNumber.innerHTML = crmDataObject.propNum;
    }

    const floorStringElement = document.querySelector('.flat-tooltip__floor-number');
    const separator = floorStringElement.parentElement.querySelector('.subtitle-separator');
    const numberFloorElement = floorStringElement.querySelector('.flat-tooltip__floor-number-floor');
    if (!b.isOneFloorBuilding(crmDataObject.buildingEngineId)) {
        floorStringElement?.classList.remove('hidden');
        separator?.classList.remove('hidden');
        // subtitleBox?.classList.remove('hidden');

        if (tooltipFloorNum) {
            const isGroundFloor = settingsData.groundFloor.isActive && (parseInt(settingsData.groundFloor.floor) === parseInt(crmDataObject.floorNum));
            if (isGroundFloor) {
                numberFloorElement.classList.add('hidden');
                tooltipFloorNum.innerHTML = changeLangToCurrent(settingsData.groundFloor.fullLabel);
            } else {
                numberFloorElement.classList.remove('hidden');
                
                const currentLang = getCurrentLang();
                if (currentLang === 'en') {
                    numberFloorElement.innerHTML = addFloorOrdinalSuffix(crmDataObject.floorNum);
                    tooltipFloorNum.innerHTML = '';
                } else {
                    numberFloorElement.innerHTML = changeLangToCurrent('floor');
                    tooltipFloorNum.innerHTML = crmDataObject.floorNum;
                }
            }
        }

    } else {
        floorStringElement?.classList.add('hidden');
        separator?.classList.add('hidden');
        // subtitleBox?.classList.add('hidden');
    }


    const regExp = /[a-z\u0590-\u05fe]/gi;
    const isStringName = regExp.test(name);
    if (Buildings.getBuildingsInfoLength() > 1 /*&& !Buildings.isOneFloorBuilding(crmDataObject.buildingEngineId)*/) {
        if (!isStringName) {
            let towerNumber =  document.querySelector('.flat-tooltip__tower-name_num');
            let towerTitle = document.querySelector('.flat-tooltip__tower-name_title');

            if (!towerNumber) {
                towerNumber = new BaseElement('span')
                  .addClass('flat-tooltip__tower-name_num', 'language-string')
                  .addAttribute('data-dictionary', 'building')
                  .appendTo(tooltipTowerName)
                  .DOMElement;
                towerTitle = new BaseElement('span')
                  .addClass('flat-tooltip__tower-name_title')
                  .appendTo(tooltipTowerName)
                  .DOMElement;
            }
            towerTitle.innerHTML = name;
            towerNumber.innerHTML = changeLangToCurrent('building')  + ' ';
        } else {
            tooltipTowerName.innerHTML = name;
        }
    }

    price && price.setPrice(crmDataObject);
}

const updateTooltipInfoPoints = (crmDataObject) => {
    let tooltipInfoPoint = document.querySelector('.flat-tooltip__info-points');
    tooltipInfoPoint.innerHTML = '';
    const regExp = /([A-Za-z])\w+/g;
    const measurement = config.localization.area ? config.localization.area : "m2";
    const cardsInfo = dataArrayOfFlat(crmDataObject);
    const infoPointsData = cardsInfo.filter((data) => {
        if (getFieldsFromAPI.smallCard().indexOf(data.name) !== -1)
            return data;
    })

    infoPointsData.forEach((data) => {
        let value;

        data.exceptions
          ? value = data.exceptions[data.data]
          : value = data.data;

        if (data.name === 'storages' && Array.isArray(value)) {
            const valueCopy = [ ...value ];
            value = 0;
            valueCopy.forEach(item => {
                value += item.size;
            });
        }

        if (parseInt(value) === 0 || value === undefined)
            return;

        const cardContentBlock = new BaseElement()
          .addClass('flat-tooltip-card__info-points-block', 'card__info-points-block')
          .appendTo(tooltipInfoPoint)
          .DOMElement;
        const cardContentWrapper = new BaseElement()
          .addClass('flat-tooltip-card__info-points-wrapper', 'card__info-points-block-wrapper')
          .appendTo(cardContentBlock)
          .DOMElement;
        const cardModelName = new BaseElement()
          .addClass(`flat-tooltip-card__info-points-block_data`, 'card__info-points-block_data')
          .appendTo(cardContentWrapper)
          .DOMElement;
        const cardModelNameText = new BaseElement('span')
          .addClass(`flat-tooltip-card__info-points-block_data_text`, 'card__info-points-block_data_text', isNumeric(value) ? 'translate-number' : 'language-string')
          .addAttribute('data-dictionary', value)
          .appendTo(cardModelName);
        const contentSubtext = new BaseElement()
          .addClass(`flat-tooltip-card__info-points-block_subtitle`, 'card__info-points-block_subtitle')
          .appendTo(cardContentWrapper)
          .DOMElement;

        if (regExp.test(value))
            cardModelNameText.addStyle('direction', 'ltr');
            // cardModelNameText.style.direction = "ltr";

        contentSubtext.innerHTML += `<span class="language-string" data-dictionary="${data.name}">${changeLangToCurrent(data.name).toLowerCase()}</span>`;

        switch(data.name) {
            case 'area':
            case 'balcony size':
            case 'roof balcony size':
            case 'covered balcony size':
            case 'basement size':
            case 'storages':
                const coma = `<span>,</span>`;
                contentSubtext.innerHTML += coma;
                new BaseElement('span')
                  .addClass('language-string', 'card__info-points-block_subtitle-measurement', 'meters')
                  .addAttribute('data-dictionary', measurement)
                  .innerHtml(/*contentSubtext + */changeLangToCurrent(measurement))
                  .appendTo(contentSubtext);
                break;
            case 'exposure':
                if (Boolean(!value))
                    return;

                const dictionary = facingDictionary();
                let exposureString = '';

                if (!Array.isArray(value))
                    value = value.split(',');
                if (value.length === 0) {
                    cardContentBlock.remove();
                    return;
                }

                value.forEach((exposure, index) => {
                    exposureString += changeLangToCurrent(dictionary[exposure].en + 'Short');
                    if (index !== value.length - 1)
                        exposureString += ', ';
                });
                value = exposureString;
                break;
            case 'accessible':
            case 'tenantPrice':
            case 'treatmentRoom':
                cardModelNameText
                  .innerHtml('')
                  .addClass('icon-check-mark');
                break;
            // case 'storages':
            case 'parkings':
                if (Boolean(!value)) {
                    cardContentBlock.remove();
                    return;
                }

                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        cardContentBlock.remove();
                        return;
                    }

                    value = value.length;
                }

                cardModelNameText.innerHtml(value);

                break;
        }

        const listOfExceptions = [
            'accessible',
            'treatmentRoom',
            'tenantPrice',
            // 'storages',
            'parkings'
        ]

        if (!listOfExceptions.includes(data.name))
            cardModelNameText.innerHtml(isNumeric(value) ? numberWithCommas(value) : changeLangToCurrent(value));
        cardModelName.classList.add(data.icon);
    });

    setInfoPointsLayoutDependsOnChildren(tooltipInfoPoint);
};

export const updateTooltipPosition = (hoveredObject) => {
    if (hoveredObject && !hoveredObject?.userData.isClicked)
        showTooltip();
    return hoveredObject;
};

export const hideTooltip = () => {
    if (isMobile)
        return;

    if (tooltip) {
        tooltip.style.transition = '';
        tooltip.style.display = 'none';
        tooltip.style.opacity = 0;
    }
};

export const showTooltip = () => {
    const isKeyplanAmenity = config.features?.keyplanAmenities && settingsData.selectedObject?.userData?.customSelection;
    if ((settingsData.buildingDestroyed && !isKeyplanAmenity) || isDesktop)
        return;
    if (settingsData.activeViewMode === ViewMode.Orbit)
        return;

    tooltip.style.display = 'block';
    tooltip.style.opacity = 1;

    const tooltipWidth = tooltip.getBoundingClientRect().width;
    const tooltipHeight = tooltip.getBoundingClientRect().height;
    const dir = document.documentElement.getAttribute('dir');
    const searchBlock = document.getElementsByClassName('search__container-main')[0];
    const menu = document.getElementsByClassName('aside__container')[0];
    const border = {
        bottom: 0,
        top: window.innerHeight,
        left: 0,
        right: window.innerWidth,
    }
    let menuWidth = 0 ;
    let searchWidth = 0 ;
    if (searchBlock && menu) {
        menuWidth = parseInt(getComputedStyle(menu).width);
        searchWidth = parseInt(getComputedStyle(searchBlock).width);
    }

    if (dir === 'ltr') {
        border.right = window.innerWidth;
        border.left = menuWidth + searchWidth;
    } else if (dir === 'rtl') {
        border.right = window.innerWidth - (menuWidth + searchWidth);
        border.left = 0;
    }

    (threeJsVariables.mouse.winX + 25 + tooltipWidth) < border.right ?
      tooltip.style.left = threeJsVariables.mouse.winX + 25 + 'px':
      tooltip.style.left = threeJsVariables.mouse.winX - tooltipWidth - 25 + 'px';

    (threeJsVariables.mouse.winY + 25 + tooltipHeight) < window.innerHeight ?
      tooltip.style.top = threeJsVariables.mouse.winY + 25 + 'px':
      tooltip.style.top = threeJsVariables.mouse.winY - tooltipHeight - 25 + 'px';
    tooltip.style.opacity = 1;
};
